// import Vue from 'vue'
// import VueRouter from 'vue-router'
// import deviceDetect from '@/utils/device'
//
// Vue.use(VueRouter)
//
// // 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
//
// // 定义路由路径与角色的映射
// const rolePathMap = {
//   ADMIN: ['/home', '/admin', '/user', '/adminPerson', '/password', '/notice', '/course',
//     '/score', '/information', '/orders', '/scoreOrder', '/fileOrder', '/comment', '/xunfeiSpark','/aimodel','/ai-messages','/generatedImage','/channelManage'],
//   USER: ['/front']
// }
//
// // 不需要登录就能访问的白名单路径
// const whiteList = ['/login', '/login2', '/register', '/terms', '/privacy', '/contact', '/ocean','/warm','/wish','/journey']
//
// const routes = [
//   {
//     path: '/',
//     name: 'Manager',
//     component: () => import('../views/Manager.vue'),
//     redirect: '/home',  // 重定向到主页
//     children: [
//       { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
//       { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
//       { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
//       { path: 'user', name: 'User', meta: { name: '用户信息' }, component: () => import('../views/manager/User') },
//       { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
//       { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
//       { path: 'notice', name: 'Notice', meta: { name: '公告信息' }, component: () => import('../views/manager/Notice') },
//       { path: 'course', name: 'Course', meta: { name: '课程信息' }, component: () => import('../views/manager/Course') },
//       { path: 'score', name: 'Score', meta: { name: '积分专区' }, component: () => import('../views/manager/Score') },
//       { path: 'information', name: 'Information', meta: { name: '资料审核' }, component: () => import('../views/manager/Information') },
//       { path: 'orders', name: 'Orders', meta: { name: '课程订单' }, component: () => import('../views/manager/Orders') },
//       { path: 'scoreOrder', name: 'ScoreOrder', meta: { name: '积分兑课' }, component: () => import('../views/manager/ScoreOrder') },
//       { path: 'fileOrder', name: 'FileOrder', meta: { name: '资料下载' }, component: () => import('../views/manager/FileOrder') },
//       { path: 'comment', name: 'Comment', meta: { name: '课程评论' }, component: () => import('../views/manager/Comment') },
//       { path: 'xunfeiSpark', name: 'XunfeiSpark', meta: { name: 'AI助手' }, component: () => import('../views/manager/XunfeiSpark') },
//       { path: 'aimodel', name: 'aimodel', meta: { name: 'AI模型' }, component: () => import('../views/manager/AiModel.vue') },
//       // 在 Manager 的 children 中添加
//       {
//         path: 'ai-messages',
//         name: 'AiMessages',
//         meta: { name: '消息审计' },
//         component: () => import('../views/manager/AiMessages.vue')
//       },
//       // 管理端路由（在管理后台路由中添加）
//       {
//         path: 'generatedImage',
//         name: 'GeneratedImage',
//         meta: { name: 'AI图片管理' },
//         component: () => import('../views/manager/GeneratedImageManager.vue')
//       },
//       // 在 Manager 的 children 末尾追加
//       {
//         path: 'channelManage',
//         name: 'ChannelManage',
//         meta: { name: '渠道管理' },
//         component: () => import('../views/manager/ChannelManage.vue')
//       },
//     ]
//   },
//   {
//     path: '/front',
//     name: 'Front',
//     component: () => import('../views/Front.vue'),
//     children: [
//       { path: 'home', name: 'FrontHome', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
//       { path: 'course', name: 'FrontCourse', meta: { name: '全部课程' }, component: () => import('../views/front/Course') },
//       { path: 'courseDetail', name: 'CourseDetail', meta: { name: '课程详情' }, component: () => import('../views/front/CourseDetail') },
//       { path: 'scoreDetail', name: 'ScoreDetail', meta: { name: '积分详情' }, component: () => import('../views/front/ScoreDetail') },
//       { path: 'score', name: 'FrontScore', meta: { name: '积分专区' }, component: () => import('../views/front/Score') },
//       { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/front/Person') },
//       {
//         path: 'person-mobile',
//         name: 'PersonMobile',
//         meta: {
//           platform: 'mobile',
//           name: '移动端个人信息'
//         },
//         component: () => import('../views/front/PersonMobile.vue')
//       },
//       {
//         path: '/front/wallet',
//         name: 'wallet',
//         component: () => import('@/views/front/WalletMobile.vue')
//       },
//       { path: 'member', name: 'MemberCenter', meta: { name: '个人信息' }, component: () => import('../views/front/MemberCenter') },
//       { path: 'myInfo', name: 'MyInfo', meta: { name: '我的资料' }, component: () => import('../views/front/MyInfo') },
//       { path: 'information', name: 'FrontInformation', meta: { name: '海量资源' }, component: () => import('../views/front/Information') },
//       { path: 'informationDetail', name: 'InformationDetail', meta: { name: '资料详情' }, component: () => import('../views/front/InformationDetail') },
//       { path: 'orders', name: 'FrontOrders', meta: { name: '已购课程' }, component: () => import('../views/front/Orders') },
//       { path: 'scoreOrder', name: 'FrontScoreOrder', meta: { name: '我的兑换' }, component: () => import('../views/front/ScoreOrder') },
//       { path: 'fileOrder', name: 'FrontFileOrder', meta: { name: '历史下载' }, component: () => import('../views/front/FileOrder') },
//       { path: 'chatLM', name: 'ChatLM', meta: { name: 'ChatLM' }, component: () => import('../views/front/ChatLM.vue') },
//       { path: 'ChatGPT', name: 'ChatGPT', meta: { name: 'ChatGPT' }, component: () => import('../views/front/ChatGPT.vue') },
//       { path: 'GPTsStore', name: 'GPTsStore', meta: { name: 'GPTsStore' }, component: () => import('../views/front/GPTsStore.vue') },
//       { path: 'GPTs', name: 'GPTs', meta: { name: 'GPTs' }, component: () => import('../views/front/GPTs') },
//       { path: 'dall-e', name: 'DALL-E', meta: { name: 'DALL-E' }, component: () => import('../views/front/DALL-E.vue') },
//       { path: 'Claude', name: 'Claude', meta: { name: 'Claude' }, component: () => import('../views/front/Claude.vue') },
//       { path: 'voiceChat', name: 'VoiceChat', meta: { name: 'VoiceChat' }, component: () => import('../views/front/VoiceChat.vue') },
//       { path: 'GPT-4V', name: 'GPT-4V', meta: { name: 'GPT-4V' }, component: () => import('../views/front/GPT-4V.vue') },
//       { path: 'knowledgeTree', name: 'KnowledgeTree', meta: { name: '知识树' }, component: () => import('../views/front/KnowledgeTree.vue') },
//       { path: 'about', name: 'About', meta: { name: '关于我们' }, component: () => import('../views/front/About') },
//       { path: 'features', name: 'Features', meta: { name: '功能' }, component: () => import('../views/front/Features') },
//       { path: 'pricing', name: 'Pricing', meta: { name: '定价' }, component: () => import('../views/front/Pricing') },
//
//       // ✅ 新增支付相关路由
//       {
//         path: 'payment',
//         name: 'Payment',
//         meta: { name: '支付页面' },
//         component: () => import('../views/front/Payment.vue')
//       },
//
//       {
//         path: 'payment-success',
//         name: 'PaymentSuccess',
//         meta: { name: '支付成功' },
//         component: () => import('../views/front/PaymentSuccess.vue')
//       },
//
//       { path: 'case-studies', name: 'Case-studies', meta: { name: '研究案例' }, component: () => import('../views/front/CaseStudies') },
//       { path: 'blog', name: 'Blog', meta: { name: '博客' }, component: () => import('../views/front/Blog') },
//       { path: 'careers', name: 'Careers', meta: { name: '工作机会' }, component: () => import('../views/front/Careers') },
//       { path: 'news', name: 'News', meta: { name: '新闻' }, component: () => import('../views/front/News') },
//       { path: 'contact', name: 'FrontContact', meta: { name: '联系我们' }, component: () => import('../views/front/Contact') },
//       { path: 'support', name: 'Support', meta: { name: '支持中心' }, component: () => import('../views/front/SupportCenter') },
//       { path: 'documentation', name: 'Documentation', meta: { name: '文档' }, component: () => import('../views/front/Documentation') },
//       { path: 'api', name: 'api', meta: { name: 'api' }, component: () => import('../views/front/API') },
//       { path: 'status', name: 'Status', meta: { name: '系统状态' }, component: () => import('../views/front/SystemStatus') },
//       { path: 'terms', name: 'FrontTermsOfService', meta: { name: '服务条款' }, component: () => import('../views/front/TermsOfService') },
//       { path: 'privacy', name: 'FrontPrivacyPolicy', meta: { name: '隐私政策' }, component: () => import('../views/front/PrivacyPolicy') },
//       { path: 'cookies', name: 'CookiePolicy', meta: { name: 'cookie政策' }, component: () => import('../views/front/CookiePolicy') },
//       { path: 'security', name: 'Security', meta: { name: '安全' }, component: () => import('../views/front/Security') },
//       { path: 'download', name: 'Download', meta: { name: '下载' }, component: () => import('../views/front/Download') },
//       { path: 'aboutUs', name: 'aboutUs', meta: { name: '关于我们' }, component: () => import('../views/front/AboutUS') },
//       { path: 'Portfolio', name: 'FrontPortfolio', meta: { name: '作者' }, component: () => import('../views/front/Portfolio') },
//       { path: 'ocean', name: 'ocean', meta: { name: '作者' }, component: () => import('../views/front/Ocean.vue') },
//       {
//         path: 'video-generator',
//         name: 'VideoGenerator',
//         component: () => import('../views/front/VideoGenerator.vue')
//       },
//       { path: 'warm', name: 'Warm', meta: { name: '天天开心' }, component: () => import('../views/front/WarmTips.vue') },
//
//       {
//         path: 'paper-humanize',
//         name: 'PaperHumanize',
//         meta: { name: '论文去AI化' },
//         component: () => import('../views/front/PaperHumanize.vue')
//       },
//       {
//         path: 'ocean-canvas',
//         name: 'OceanCanvas',
//         meta: { name: 'Ocean Canvas' },
//         component: () => import('../views/front/GeminiImageGenerator.vue')
//       },
//       {
//         path: 'OceanVoice',
//         name: 'OceanVoice',
//         meta: { name: 'AI语音聊天' },
//         component: () => import('../views/front/AIVoice.vue')
//       },
//       // 在 Front 的 children 末尾追加
//       {
//         path: 'channel-center',
//         name: 'ChannelCenter',
//         meta: { name: '推广中心' },
//         component: () => import('../views/front/ChannelCenter.vue')
//       },
//     ]
//   },
//   { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
//   { path: '/login2', name: 'Login2', meta: { name: '登录页面' }, component: () => import('../views/Login2.vue') },
//   { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
//   { path: '/terms', name: 'TermsOfService', meta: { name: '使用条款' }, component: () => import('../views/TermsOfService.vue') },
//   { path: '/privacy', name: 'PrivacyPolicy', meta: { name: '隐私政策' }, component: () => import('../views/PrivacyPolicy.vue') },
//   { path: '/contact', name: 'Contact', meta: { name: '联系我们' }, component: () => import('../views/Contact.vue') },
//   { path: '/Portfolio', name: 'Portfolio', meta: { name: '作者' }, component: () => import('../views/Portfolio') },
//   { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
//   { path: '/ocean', name: 'ocean', meta: { name: '作者' }, component: () => import('../views/Ocean.vue') },
//   { path: '/warm', name: 'Warm', meta: { name: '天天开心' }, component: () => import('../views/WarmTips.vue') },
//   { path: '/wish', name: 'Wish', meta: { name: '希望' }, component: () => import('../views/Wish.vue') },
//   { path: '/journey', name: 'Journey', meta: { name: '旅程' }, component: () => import('../views/Journey.vue') },
//   { path: '/journeyPlan', name: 'Journey', meta: { name: '旅程计划' }, component: () => import('../views/JiuzhaigouTravelPlan.vue') },
//
// ]
//
// // 动态判断路由模式
// const router = new VueRouter({
//   mode: window.Capacitor ? 'hash' : 'history',
//   base: process.env.BASE_URL,
//   routes,
//   // 🔧 关键修复：添加滚动行为配置
//   scrollBehavior(to, from, savedPosition) {
//     // 如果有保存的滚动位置（浏览器前进/后退），使用保存的位置
//     if (savedPosition) {
//       return savedPosition
//     }
//
//     // 如果路由有hash锚点，滚动到对应元素
//     if (to.hash) {
//       return {
//         selector: to.hash,
//         behavior: 'smooth'
//       }
//     }
//
//     // 默认情况：滚动到页面顶部
//     return { x: 0, y: 0 }
//   }
// })
//
// // 强制调试信息 - APP环境下始终输出
// if (window.Capacitor) {
//   console.log('🚀 Capacitor路由初始化')
//   console.log('路由模式:', window.Capacitor ? 'hash' : 'history')
//   console.log('运行环境:', window.Capacitor ? 'Capacitor APP' : 'Web浏览器')
//   console.log('当前URL:', window.location.href)
// }
//
// // 检查用户是否有权限访问该路径
// function hasPermission(userRole, path) {
//   if (whiteList.some(item => path.startsWith(item))) {
//     return true
//   }
//   if (path === '/404' || path === '/403') {
//     return true
//   }
//   if (userRole === 'ADMIN') {
//     return rolePathMap.ADMIN.some(item => path.startsWith(item))
//   } else if (userRole === 'USER') {
//     return rolePathMap.USER.some(item => path.startsWith(item))
//   }
//   return false
// }
//
// // 路由守卫 - 增强调试版本
// router.beforeEach((to, from, next) => {
//   // 强制调试 - APP环境下始终输出
//   if (window.Capacitor) {
//     console.log('🔄 路由守卫触发', {
//       to: to.path,
//       from: from.path,
//       fullPath: to.fullPath
//     })
//   }
//
//   // 获取用户信息
//   const user = JSON.parse(localStorage.getItem("xm-user") || '{}')
//   const isMobile = deviceDetect.isMobile()
//
//   if (window.Capacitor) {
//     console.log('👤 用户信息', {
//       role: user.role,
//       hasToken: !!user.token,
//       isMobile: isMobile
//     })
//   }
//
//   // 处理设备检测
//   if (to.path === '/front/person' || to.path === '/front/person-mobile') {
//     if (isMobile && to.path === '/front/person') {
//       if (window.Capacitor) console.log('📱 重定向到移动端个人页面')
//       next('/front/person-mobile')
//       return
//     }
//     if (!isMobile && to.path === '/front/person-mobile') {
//       if (window.Capacitor) console.log('💻 重定向到桌面端个人页面')
//       next('/front/person')
//       return
//     }
//   }
//
//   // 1. 检查是否在白名单中
//   if (whiteList.some(item => to.path.startsWith(item))) {
//     if (window.Capacitor) console.log('✅ 白名单路径，直接通过:', to.path)
//     next()
//     return
//   }
//
//   // 2. 检查用户是否登录
//   if (!user.role) {
//     if (window.Capacitor) console.log('❌ 未登录，跳转到登录页')
//     next('/login')
//     return
//   }
//
//   // 3. 特殊处理根路径
//   if (to.path === '/') {
//     if (window.Capacitor) console.log('🏠 根路径重定向处理')
//
//     if (user.role === 'USER') {
//       if (window.Capacitor) console.log('👥 普通用户，重定向到 /front/home')
//       router.replace('/front/home')
//       return
//     } else if (user.role === 'ADMIN') {
//       if (window.Capacitor) console.log('👨‍💼 管理员，重定向到 /home')
//       router.replace('/home')
//       return
//     } else {
//       if (window.Capacitor) console.log('❓ 未知角色，跳转到登录页')
//       next('/login')
//       return
//     }
//   }
//
//   // 4. 用户权限验证
//   if (user.role === 'USER') {
//     if (rolePathMap.ADMIN.some(path => to.path.startsWith(path))) {
//       if (window.Capacitor) console.log('🚫 普通用户尝试访问管理员页面，重定向')
//       router.replace('/front/home')
//       return
//     }
//
//     if (to.path.startsWith('/front')) {
//       if (window.Capacitor) console.log('✅ 普通用户访问允许的路径:', to.path)
//       next()
//     } else {
//       if (window.Capacitor) console.log('🔄 普通用户访问非前台路径，重定向到首页')
//       router.replace('/front/home')
//     }
//   } else if (user.role === 'ADMIN') {
//     if (hasPermission(user.role, to.path)) {
//       if (window.Capacitor) console.log('✅ 管理员访问允许的路径:', to.path)
//       next()
//     } else {
//       if (window.Capacitor) console.log('🚫 管理员访问禁止的路径，跳转到403')
//       next('/403')
//     }
//   } else {
//     if (window.Capacitor) console.log('❓ 未知用户角色，跳转到登录页')
//     next('/login')
//   }
// })
//
// // 路由完成后的处理
// router.afterEach((to, from) => {
//   if (window.Capacitor) {
//     console.log('✅ 路由跳转完成', {
//       to: to.path,
//       from: from.path
//     })
//   }
// })
//
// // 路由错误处理
// router.onError((error) => {
//   if (window.Capacitor) {
//     console.error('💥 路由错误:', error)
//     // 发生错误时强制跳转到前台首页
//     setTimeout(() => {
//       router.replace('/front/home')
//     }, 100)
//   }
// })
//
// // 路由准备完成
// router.onReady(() => {
//   if (window.Capacitor) {
//     console.log('🎯 路由系统准备就绪')
//     console.log('当前路径:', router.currentRoute.path)
//   }
// })
//
// export default router
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 定义路由路径与角色的映射
const rolePathMap = {
  ADMIN: ['/home', '/admin', '/user', '/adminPerson', '/password', '/notice', '/course','/claude','/vault', '/game',
    '/score', '/information', '/orders', '/scoreOrder', '/fileOrder', '/comment', '/xunfeiSpark','/aimodel','/ai-messages','/generatedImage','/channelManage','/aiPaperAdmin','/paperOrderAdmin'],
  USER: ['/front','/claude','/vault', '/game']
}

// 不需要登录就能访问的白名单路径
// /admin/login 必须显式加入 —— 它虽以 /admin 开头(属于 ADMIN 权限路径),
// 但作为登录入口需允许未登录访问。白名单检查先于权限检查,顺序安全。
const whiteList = ['/login', '/login2', '/admin/login', '/register', '/terms', '/privacy', '/contact', '/ocean','/warm','/wish','/journey', '/game']

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',  // 重定向到主页
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
      { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
      { path: 'user', name: 'User', meta: { name: '用户信息' }, component: () => import('../views/manager/User') },
      { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
      { path: 'notice', name: 'Notice', meta: { name: '公告信息' }, component: () => import('../views/manager/Notice') },
      { path: 'course', name: 'Course', meta: { name: '课程信息' }, component: () => import('../views/manager/Course') },
      { path: 'score', name: 'Score', meta: { name: '积分专区' }, component: () => import('../views/manager/Score') },
      { path: 'information', name: 'Information', meta: { name: '资料审核' }, component: () => import('../views/manager/Information') },
      { path: 'orders', name: 'Orders', meta: { name: '课程订单' }, component: () => import('../views/manager/Orders') },
      { path: 'scoreOrder', name: 'ScoreOrder', meta: { name: '积分兑课' }, component: () => import('../views/manager/ScoreOrder') },
      { path: 'fileOrder', name: 'FileOrder', meta: { name: '资料下载' }, component: () => import('../views/manager/FileOrder') },
      { path: 'comment', name: 'Comment', meta: { name: '课程评论' }, component: () => import('../views/manager/Comment') },
      { path: 'xunfeiSpark', name: 'XunfeiSpark', meta: { name: 'AI助手' }, component: () => import('../views/manager/XunfeiSpark') },
      { path: 'aimodel', name: 'aimodel', meta: { name: 'AI模型' }, component: () => import('../views/manager/AiModel.vue') },
      // 在 Manager 的 children 中添加
      {
        path: 'ai-messages',
        name: 'AiMessages',
        meta: { name: '消息审计' },
        component: () => import('../views/manager/AiMessages.vue')
      },
      // 管理端路由（在管理后台路由中添加）
      {
        path: 'generatedImage',
        name: 'GeneratedImage',
        meta: { name: 'AI图片管理' },
        component: () => import('../views/manager/GeneratedImageManager.vue')
      },
      // 在 Manager 的 children 末尾追加
      {
        path: 'channelManage',
        name: 'ChannelManage',
        meta: { name: '渠道管理' },
        component: () => import('../views/manager/ChannelManage.vue')
      },
      {
        path: '/aiPaperAdmin',
        name: 'AiPaperAdmin',
        component: () => import('../views/manager/AiPaperAdmin.vue'),
        meta: { title: 'AI论文管理' }
      },
      {
        path: '/paperOrderAdmin',
        name: 'PaperOrderAdmin',
        component: () => import('../views/manager/PaperOrderAdmin.vue'),
        meta: { name: '论文订单', title: '论文订单管理' }
      }
    ]
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Front.vue'),
    children: [
      { path: 'home', name: 'FrontHome', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
      { path: 'course', name: 'FrontCourse', meta: { name: '全部课程' }, component: () => import('../views/front/Course') },
      { path: 'courseDetail', name: 'CourseDetail', meta: { name: '课程详情' }, component: () => import('../views/front/CourseDetail') },
      { path: 'scoreDetail', name: 'ScoreDetail', meta: { name: '积分详情' }, component: () => import('../views/front/ScoreDetail') },
      { path: 'score', name: 'FrontScore', meta: { name: '积分专区' }, component: () => import('../views/front/Score') },
      { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/front/Person') },
      { path: 'member', name: 'MemberCenter', meta: { name: '个人信息' }, component: () => import('../views/front/MemberCenter') },
      { path: 'myInfo', name: 'MyInfo', meta: { name: '我的资料' }, component: () => import('../views/front/MyInfo') },
      { path: 'information', name: 'FrontInformation', meta: { name: '海量资源' }, component: () => import('../views/front/Information') },
      { path: 'informationDetail', name: 'InformationDetail', meta: { name: '资料详情' }, component: () => import('../views/front/InformationDetail') },
      { path: 'orders', name: 'FrontOrders', meta: { name: '已购课程' }, component: () => import('../views/front/Orders') },
      { path: 'scoreOrder', name: 'FrontScoreOrder', meta: { name: '我的兑换' }, component: () => import('../views/front/ScoreOrder') },
      { path: 'fileOrder', name: 'FrontFileOrder', meta: { name: '历史下载' }, component: () => import('../views/front/FileOrder') },
      { path: 'chatLM', name: 'ChatLM', meta: { name: 'ChatLM' }, component: () => import('../views/front/ChatLM.vue') },
      { path: 'ChatGPT', name: 'ChatGPT', meta: { name: 'ChatGPT' }, component: () => import('../views/front/ChatGPT.vue') },

      { path: 'GPTsStore', name: 'GPTsStore', meta: { name: 'GPTsStore' }, component: () => import('../views/front/GPTsStore.vue') },
      { path: 'GPTs', name: 'GPTs', meta: { name: 'GPTs' }, component: () => import('../views/front/GPTs') },
      { path: 'dall-e', name: 'DALL-E', meta: { name: 'DALL-E' }, component: () => import('../views/front/DALL-E.vue') },
      { path: 'Claude', name: 'Claude', meta: { name: 'Claude' }, component: () => import('../views/front/Claude.vue') },
      { path: 'voiceChat', name: 'VoiceChat', meta: { name: 'VoiceChat' }, component: () => import('../views/front/VoiceChat.vue') },
      { path: 'GPT-4V', name: 'GPT-4V', meta: { name: 'GPT-4V' }, component: () => import('../views/front/GPT-4V.vue') },
      { path: 'knowledgeTree', name: 'KnowledgeTree', meta: { name: '知识树' }, component: () => import('../views/front/KnowledgeTree.vue') },
      { path: 'about', name: 'About', meta: { name: '关于我们' }, component: () => import('../views/front/About') },
      { path: 'features', name: 'Features', meta: { name: '功能' }, component: () => import('../views/front/Features') },
      { path: 'pricing', name: 'Pricing', meta: { name: '定价' }, component: () => import('../views/front/Pricing') },

      // ✅ 新增支付相关路由
      {
        path: 'payment',
        name: 'Payment',
        meta: { name: '支付页面' },
        component: () => import('../views/front/Payment.vue')
      },

      {
        path: 'payment-success',
        name: 'PaymentSuccess',
        meta: { name: '支付成功' },
        component: () => import('../views/front/PaymentSuccess.vue')
      },

      { path: 'case-studies', name: 'Case-studies', meta: { name: '研究案例' }, component: () => import('../views/front/CaseStudies') },
      { path: 'blog', name: 'Blog', meta: { name: '博客' }, component: () => import('../views/front/Blog') },
      { path: 'careers', name: 'Careers', meta: { name: '工作机会' }, component: () => import('../views/front/Careers') },
      { path: 'news', name: 'News', meta: { name: '新闻' }, component: () => import('../views/front/News') },
      { path: 'contact', name: 'FrontContact', meta: { name: '联系我们' }, component: () => import('../views/front/Contact') },
      { path: 'support', name: 'Support', meta: { name: '支持中心' }, component: () => import('../views/front/SupportCenter') },
      { path: 'documentation', name: 'Documentation', meta: { name: '文档' }, component: () => import('../views/front/Documentation') },
      { path: 'api', name: 'api', meta: { name: 'api' }, component: () => import('../views/front/API') },
      { path: 'status', name: 'Status', meta: { name: '系统状态' }, component: () => import('../views/front/SystemStatus') },
      { path: 'terms', name: 'FrontTermsOfService', meta: { name: '服务条款' }, component: () => import('../views/front/TermsOfService') },
      { path: 'privacy', name: 'FrontPrivacyPolicy', meta: { name: '隐私政策' }, component: () => import('../views/front/PrivacyPolicy') },
      { path: 'cookies', name: 'CookiePolicy', meta: { name: 'cookie政策' }, component: () => import('../views/front/CookiePolicy') },
      { path: 'security', name: 'Security', meta: { name: '安全' }, component: () => import('../views/front/Security') },
      { path: 'download', name: 'Download', meta: { name: '下载' }, component: () => import('../views/front/Download') },
      { path: 'aboutUs', name: 'aboutUs', meta: { name: '关于我们' }, component: () => import('../views/front/AboutUS') },
      { path: 'Portfolio', name: 'FrontPortfolio', meta: { name: '作者' }, component: () => import('../views/front/Portfolio') },
      { path: 'ocean', name: 'ocean', meta: { name: '作者' }, component: () => import('../views/front/Ocean.vue') },
      {
        path: 'video-generator',
        name: 'VideoGenerator',
        component: () => import('../views/front/VideoGenerator.vue')
      },
      { path: 'warm', name: 'Warm', meta: { name: '天天开心' }, component: () => import('../views/front/WarmTips.vue') },

      {
        path: 'paper-humanize',
        name: 'PaperHumanize',
        meta: { name: '论文去AI化' },
        component: () => import('../views/front/PaperHumanize.vue')
      },
      {
        path: 'ocean-canvas',
        name: 'OceanCanvas',
        meta: { name: 'Ocean Canvas' },
        component: () => import('../views/front/GeminiImageGenerator.vue')
      },
      {
        path: 'OceanVoice',
        name: 'OceanVoice',
        meta: { name: 'AI语音聊天' },
        component: () => import('../views/front/AIVoice.vue')
      },
      // 在 Front 的 children 末尾追加
      {
        path: 'channel-center',
        name: 'ChannelCenter',
        meta: { name: '推广中心' },
        component: () => import('../views/front/ChannelCenter.vue')
      },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  // 旧 /login2 路径 —— 兼容老书签,自动跳转到新的统一登录页 /login
  { path: '/login2', redirect: '/login' },
  // 管理员登录入口 —— 视觉与 /login 一致,但带 Admin 徽章,提交 role='ADMIN'
  { path: '/admin/login', name: 'AdminLogin', meta: { name: '管理员登录' }, component: () => import('../views/AdminLogin.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '/terms', name: 'TermsOfService', meta: { name: '使用条款' }, component: () => import('../views/TermsOfService.vue') },
  { path: '/privacy', name: 'PrivacyPolicy', meta: { name: '隐私政策' }, component: () => import('../views/PrivacyPolicy.vue') },
  { path: '/contact', name: 'Contact', meta: { name: '联系我们' }, component: () => import('../views/Contact.vue') },
  { path: '/Portfolio', name: 'Portfolio', meta: { name: '作者' }, component: () => import('../views/Portfolio') },
  { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
  { path: '/ocean', name: 'ocean', meta: { name: '作者' }, component: () => import('../views/Ocean.vue') },
  { path: '/warm', name: 'Warm', meta: { name: '天天开心' }, component: () => import('../views/WarmTips.vue') },
  { path: '/wish', name: 'Wish', meta: { name: '希望' }, component: () => import('../views/Wish.vue') },
  { path: '/journey', name: 'Journey', meta: { name: '旅程' }, component: () => import('../views/Journey.vue') },
  { path: '/journeyPlan', name: 'Journey', meta: { name: '旅程计划' }, component: () => import('../views/JiuzhaigouTravelPlan.vue') },
  // 在 const routes = [...] 数组里，跟 /login、/register 同级（顶级路由）
  {
    path: '/claude',
    name: 'Claude',
    meta: { name: 'Claude' },
    component: () => import('@/views/front/ClaudeChat.vue')
  },
  // 墨库 Markdown Vault —— 与 /claude 同为整屏独立工具，故同样顶级独立（绕开 /front 布局与全局样式污染）
  {
    path: '/vault',
    name: 'MarkdownVault',
    meta: { name: '墨库' },
    component: () => import('@/views/front/MarkdownVault.vue')
  },
  // 在 routes 数组里，跟 /claude、/vault 同级追加：
  {
    path: '/game',
    name: 'StarfallValley',
    meta: { name: '星陨谷' },
    component: () => import('@/views/front/StarfallValley.vue')
  },

]

// 动态判断路由模式
const router = new VueRouter({
  mode: window.Capacitor ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes,
  // 🔧 关键修复：添加滚动行为配置
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的滚动位置（浏览器前进/后退），使用保存的位置
    if (savedPosition) {
      return savedPosition
    }

    // 如果路由有hash锚点，滚动到对应元素
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }

    // 默认情况：滚动到页面顶部
    return { x: 0, y: 0 }
  }
})

// 强制调试信息 - APP环境下始终输出
if (window.Capacitor) {
  console.log('🚀 Capacitor路由初始化')
  console.log('路由模式:', window.Capacitor ? 'hash' : 'history')
  console.log('运行环境:', window.Capacitor ? 'Capacitor APP' : 'Web浏览器')
  console.log('当前URL:', window.location.href)
}

// 检查用户是否有权限访问该路径
function hasPermission(userRole, path) {
  if (whiteList.some(item => path.startsWith(item))) {
    return true
  }
  if (path === '/404' || path === '/403') {
    return true
  }
  if (userRole === 'ADMIN') {
    return rolePathMap.ADMIN.some(item => path.startsWith(item))
  } else if (userRole === 'USER') {
    return rolePathMap.USER.some(item => path.startsWith(item))
  }
  return false
}

// 路由守卫 - 增强调试版本
router.beforeEach((to, from, next) => {
  // 强制调试 - APP环境下始终输出
  if (window.Capacitor) {
    console.log('🔄 路由守卫触发', {
      to: to.path,
      from: from.path,
      fullPath: to.fullPath
    })
  }

  // 获取用户信息
  const user = JSON.parse(localStorage.getItem("xm-user") || '{}')

  if (window.Capacitor) {
    console.log('👤 用户信息', {
      role: user.role,
      hasToken: !!user.token
    })
  }

  // 1. 检查是否在白名单中
  if (whiteList.some(item => to.path.startsWith(item))) {
    if (window.Capacitor) console.log('✅ 白名单路径，直接通过:', to.path)
    next()
    return
  }

  // 2. 检查用户是否登录
  if (!user.role) {
    if (window.Capacitor) console.log('❌ 未登录，跳转到登录页')
    next('/login')
    return
  }

  // 3. 特殊处理根路径
  if (to.path === '/') {
    if (window.Capacitor) console.log('🏠 根路径重定向处理')

    if (user.role === 'USER') {
      if (window.Capacitor) console.log('👥 普通用户，重定向到 /front/home')
      router.replace('/front/home')
      return
    } else if (user.role === 'ADMIN') {
      if (window.Capacitor) console.log('👨‍💼 管理员，重定向到 /home')
      router.replace('/home')
      return
    } else {
      if (window.Capacitor) console.log('❓ 未知角色，跳转到登录页')
      next('/login')
      return
    }
  }

  // 4. 用户权限验证
  if (user.role === 'USER') {
    // 优先：路径在 USER 允许列表里就直接放行
    // （如果同时也在 ADMIN 列表里，比如 /claude，也以 USER 优先为准）
    if (rolePathMap.USER.some(p => to.path.startsWith(p))) {
      if (window.Capacitor) console.log('✅ 普通用户访问允许的路径:', to.path)
      next()
      return
    }

    // 不在 USER 允许列表，再看是不是 ADMIN 专属
    if (rolePathMap.ADMIN.some(p => to.path.startsWith(p))) {
      if (window.Capacitor) console.log('🚫 普通用户尝试访问管理员页面，重定向')
      router.replace('/front/home')
      return
    }

    // 既不在 USER 也不在 ADMIN：默认踢回首页
    if (window.Capacitor) console.log('🔄 普通用户访问未授权路径，重定向到首页')
    router.replace('/front/home')
  } else if (user.role === 'ADMIN') {
    if (hasPermission(user.role, to.path)) {
      if (window.Capacitor) console.log('✅ 管理员访问允许的路径:', to.path)
      next()
    } else {
      if (window.Capacitor) console.log('🚫 管理员访问禁止的路径，跳转到403')
      next('/403')
    }
  } else {
    if (window.Capacitor) console.log('❓ 未知用户角色，跳转到登录页')
    next('/login')
  }
})

// 路由完成后的处理
router.afterEach((to, from) => {
  if (window.Capacitor) {
    console.log('✅ 路由跳转完成', {
      to: to.path,
      from: from.path
    })
  }
})

// 路由错误处理
router.onError((error) => {
  if (window.Capacitor) {
    console.error('💥 路由错误:', error)
    // 发生错误时强制跳转到前台首页
    setTimeout(() => {
      router.replace('/front/home')
    }, 100)
  }
})

// 路由准备完成
router.onReady(() => {
  if (window.Capacitor) {
    console.log('🎯 路由系统准备就绪')
    console.log('当前路径:', router.currentRoute.path)
  }
})

export default router